import type { BaseTranslation } from '../i18n-types';

export const paymentFailure = {
    header: 'Unfortunately your payment has failed',
    text: 'Something went wrong and {billingName} couldn\'t accept your payment. Please try again later.',
    buttonTryAgain: 'Try again',
    buttonGoToMain: 'Go to the main page',
    cascade: {
        title: 'The Processor Denied the Transaction',
        description: 'We will automatically send you to a backup Processor&nbsp;in&nbsp;a&nbsp;few&nbsp;seconds. If you are not redirected,&nbsp;please&nbsp;',
        click: 'click here',
        toast: 'Transaction declined. Please, try again with another payment method.',
    },
} satisfies BaseTranslation;
